// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3KRC7","title":"ClientReferral_title__bkyqy","itemText":"ClientReferral_itemText__3OCJM"};